import React, { useState, useEffect } from "react";
import "../styles/CarouselSection.css";

function CarouselSection() {
  const slides = [
    {
      image: "/Banner.jpeg",
      text: "Expert Legal Guidance for Your Needs"
    },
    {
      image: "/Banner.jpeg",
      text: "We Hear You, to Be Your Voice"
    },
    {
      image: "/Banner.jpeg",
      text: "Protecting Your Rights with Integrity"
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === slides.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <section className="carousel-section">
      <div className="carousel-container">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`carousel-slide ${index === currentIndex ? "active" : ""}`}
            style={{ backgroundImage: `url(${slide.image || "/default.jpg"})` }}
          >
            {/* Overlay layer */}
            <div className="carousel-overlay">
              <h2>{slide.text}</h2>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default CarouselSection;
